import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

export const CIRCLE_3_PATTERN: SkillCastPattern = () => {
  return {
    [Direction.N]: [
      [-1, 0],
      [0, -1],
      [0, 1],
      [1, 0],
      [-1, -1],
      [-1, 1],
      [1, -1],
      [1, 1],
      [-2, 0],
      [0, -2],
      [0, 2],
      [2, 0],
      [-2, -1],
      [-2, 1],
      [-1, -2],
      [-1, 2],
      [1, -2],
      [1, 2],
      [2, -1],
      [2, 1],
      [-3, 0],
      [0, -3],
      [0, 3],
      [3, 0],
    ],

    [Direction.NE]: [],

    [Direction.E]: [],

    [Direction.SE]: [],

    [Direction.S]: [],

    [Direction.SW]: [],

    [Direction.W]: [],

    [Direction.NW]: [],
  };
};
